const buildTeamBlockRows = ({ side, x, y, width, rowHeight, gap, count = 5 }) => (
  Array.from({ length: count }, (_, index) => ({
    id: `${side}-${index + 1}`,
    rowIndex: index,
    bounds: {
      x,
      y: y + (index * (rowHeight + gap)),
      width,
      height: rowHeight,
    },
  }))
);

const buildRankingRows = ({ y, rowHeight, gap, count = 10 }) => (
  Array.from({ length: count }, (_, index) => ({
    id: `rank-${index + 1}`,
    rowIndex: index,
    bounds: {
      x: 0.09,
      y: y + (index * (rowHeight + gap)),
      width: 0.82,
      height: rowHeight,
    },
  }))
);

export const CONTROL_LAYOUTS = {
  matchDetails: {
    expected: { blue: 5, red: 5 },
    warningThreshold: 2,
    fields: {
      player: { xStart: 0.03, xEnd: 0.39, yStart: 0.05, yEnd: 0.95 },
      score: { xStart: 0.38, xEnd: 0.55, yStart: 0.08, yEnd: 0.92 },
      kda: { xStart: 0.54, xEnd: 0.78, yStart: 0.08, yEnd: 0.92 },
      impact: { xStart: 0.76, xEnd: 0.98, yStart: 0.08, yEnd: 0.92 },
    },
    rows: [
      ...buildTeamBlockRows({ side: 'left', x: 0.07, y: 0.31, width: 0.4, rowHeight: 0.052, gap: 0.008 }),
      ...buildTeamBlockRows({ side: 'right', x: 0.53, y: 0.31, width: 0.4, rowHeight: 0.052, gap: 0.008 }),
    ],
  },
  impactDetails: {
    expected: { blue: 5, red: 5 },
    warningThreshold: 2,
    fields: {
      player: { xStart: 0.03, xEnd: 0.39, yStart: 0.05, yEnd: 0.95 },
      damage: { xStart: 0.38, xEnd: 0.58, yStart: 0.08, yEnd: 0.92 },
      captureKills: { xStart: 0.76, xEnd: 0.98, yStart: 0.08, yEnd: 0.92 },
    },
    rows: [
      ...buildTeamBlockRows({ side: 'left', x: 0.07, y: 0.31, width: 0.4, rowHeight: 0.052, gap: 0.008 }),
      ...buildTeamBlockRows({ side: 'right', x: 0.53, y: 0.31, width: 0.4, rowHeight: 0.052, gap: 0.008 }),
    ],
  },
  propDetails: {
    expected: null,
    warningThreshold: 6,
    fields: {
      player: { xStart: 0.02, xEnd: 0.34, yStart: 0.05, yEnd: 0.95 },
      operatorValue: { xStart: 0.62, xEnd: 0.8, yStart: 0.08, yEnd: 0.92 },
    },
    rows: buildRankingRows({ y: 0.2, rowHeight: 0.057, gap: 0.006, count: 10 }),
  },
};

export const getControlLayout = (category) => CONTROL_LAYOUTS[category] || CONTROL_LAYOUTS.matchDetails;
